import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";
import { IStudytopic } from "../../../Pages/StudyNote.tsx/IStudyNote";

export const ListSubjectNoteTopicSlice = createSlice({
  name: "ListSubjectNoteTopicSlice",
  initialState: {} as IReduxState<IStudytopic[]>,

  reducers: {
    listListSubjectNoteTopicSlice: (state, _: PayloadAction<IStudytopic>) => {
      state.isLoading = true;
    },
    successListSubjectNoteTopicSlice: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureListSubjectNoteTopicSlice: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const {
  listListSubjectNoteTopicSlice,
  successListSubjectNoteTopicSlice,
  failureListSubjectNoteTopicSlice,
} = ListSubjectNoteTopicSlice.actions;

export default ListSubjectNoteTopicSlice.reducer;
